import { useState } from 'react';
import { Grid, Paper, Typography, Button, Pagination } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import InfoIcon from '@mui/icons-material/Info';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

const TrainingBlock = ({ trainingsData, handleOpenModal, handleDelete, handleRowClick }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const ITEMS_PER_PAGE = 10; // You can adjust the number of items displayed per page as needed.
  const intl = useIntl();

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIndex = startIndex + ITEMS_PER_PAGE;
  const displayedTrainings = trainingsData.trainings.slice(startIndex, endIndex);

  const formatDateAndTime = (dateTimeString) => {
    const date = new Date(dateTimeString);
    return `${date.toLocaleDateString(intl.locale)} ${date.toLocaleTimeString(intl.locale, {
      hour: '2-digit',
      minute: '2-digit',
    })}`;
  };

  return (
    <>
      <Grid container spacing={2}>
        {displayedTrainings.map((training) => (
          <Grid item xs={12} sm={6} md={4} key={training.id}>
            <Paper onClick={() => handleRowClick(training)} style={{ padding: '1rem', minHeight: '200px' }}>
              <Typography variant="h6" gutterBottom>
                <strong>
                  {training.name}
                </strong>
              </Typography>
              <Typography variant="body1" gutterBottom>
                <strong>
                  {intl.formatMessage({
                    id: 'training.form.label.availableSpots',
                    defaultMessage: 'Available Spots'
                  })}: {training.availableSpots}
                </strong>
              </Typography>
              <Typography variant="body1" gutterBottom>
                <strong>
                  {intl.formatMessage({
                    id: 'training.form.label.reservationTimeFrom',
                    defaultMessage: 'Reservation Time From'
                  })}: {formatDateAndTime(training.reservationTimeFrom)}
                </strong>
              </Typography>
              <Typography variant="body1" gutterBottom>
                <strong>
                  {intl.formatMessage({
                    id: 'training.form.label.reservationTimeTo',
                    defaultMessage: 'Reservation Time To'
                  })}: {formatDateAndTime(training.reservationTimeTo)}
                </strong>
              </Typography>
              <Typography variant="body1" gutterBottom>
                <strong>
                  {intl.formatMessage({
                    id: 'training.form.label.location',
                    defaultMessage: 'Location'
                  })}: {training.location}
                </strong>
              </Typography>
              <Grid container spacing={1}>
                <Grid item xs={6}>
                  <Button
                    fullWidth
                    variant="contained"
                    startIcon={<InfoIcon />}
                    onClick={(event) => {
                      event.stopPropagation();
                      handleOpenModal(training.id);
                    }}
                  >
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  <Button
                    fullWidth
                    variant="contained"
                    startIcon={<DeleteIcon />}
                    onClick={(event) => {
                      event.stopPropagation();
                      handleDelete(training);
                    }}
                  >
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        ))}
      </Grid>
      <Pagination
        count={Math.ceil(trainingsData.trainings.length / ITEMS_PER_PAGE)}
        page={currentPage}
        onChange={handlePageChange}
        style={{ marginTop: '1rem', display: 'flex', justifyContent: 'center' }}
      />
    </>
  );
};

TrainingBlock.propTypes = {
  trainingsData: PropTypes.shape({
    isFetching: PropTypes.bool.isRequired,
    trainings: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        availableSpots: PropTypes.number.isRequired,
        reservationTimeFrom: PropTypes.string.isRequired,
        reservationTimeTo: PropTypes.string.isRequired,
        location: PropTypes.string,
      })
    ).isRequired,
  }).isRequired,
  handleOpenModal: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
  handleRowClick: PropTypes.func.isRequired,
};

export { TrainingBlock };
